import { ReactElement } from 'react'
import { URLS } from '../../content/urls'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { WebTrainingScreen } from './WebTrainingScreen'
import { MobileTrainingScreen } from './MobileTrainingScreen'
import { useCookieConsent } from '../../provider/CookieConsentProvider'

export interface TrainingScreenData {
  factoryImageUrl: string
  sgsImageUrl: string
  youtubeVideoId: string
  cookiesAccepted: boolean | null
  onAcceptCookies: () => void
}

export const TrainingScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)
  const { consent, setConsent } = useCookieConsent()

  const trainingScreenData: TrainingScreenData = {
    factoryImageUrl: URLS.factoryImage,
    sgsImageUrl: URLS.sgsImage,
    youtubeVideoId: 'KYYIWG_u5ck',
    cookiesAccepted: consent,
    onAcceptCookies: (): void => {
      setConsent(true)
    },
  }

  if (isMobile) {
    return <MobileTrainingScreen data={trainingScreenData} />
  }
  return <WebTrainingScreen data={trainingScreenData} />
}
